(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('OrderRateSummaryCtrl', OrderRateSummaryCtrl);

  // @ngInject
  function OrderRateSummaryCtrl(storeKeys, filters, DateUtil, ConsumerChart, StandardReports, TransactionReports,
                                  Callout, SectionConfig, UserCohort) {
    var vm = this;
    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();
    var chartType = "values";
    
    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});


    var mau = SectionConfig.monthlyUsers;
    var monthlyOrders = SectionConfig.monthlyOrders;
    var ordersPerUser = SectionConfig.ordersPerUser;

    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.monthlyOrderSection = Callout.labelValueConfig(monthlyOrders);
    vm.monthlyOrderChartData =  function (monthlyOrders) {
      return monthlyOrders;
    };

    vm.mauSection = Callout.labelValueConfig(mau);
    vm.monthlyActiveUserChartData = function (monthlyUsers) {
      vm.tfAdoption = StandardReports.findInSummary(monthlyUsers.summary, 'TFAdoption', UserCohort.tf.value);

      return monthlyUsers;
    };

    vm.opuSection = Callout.labelValueConfig(ordersPerUser);
    vm.ordersPerUserChartData = function (ordersPerUser) {
      vm.ordersPerUserLift = StandardReports.findInSummary(ordersPerUser.summary, 'OrdersPerUserLift', UserCohort.tf.value);

      return ordersPerUser;
    };

  }
  })();
